import { render, staticRenderFns } from "./EnquiryDetailInfo.vue?vue&type=template&id=54ff7433&scoped=true&"
import script from "./EnquiryDetailInfo.vue?vue&type=script&lang=js&"
export * from "./EnquiryDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryDetailInfo.vue?vue&type=style&index=0&id=54ff7433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff7433",
  null
  
)

export default component.exports